<div class="search-block">
<div class="container">
<div>
  <div id="home_nav" class="row">
    <div class="col-md-6 col-7 col-lg-6 breadcrumb-header">
      <ol class="breadcrumb loginMenu">
        <li class="breadcrumb-item" style="align-items: center;float:right;">
          <a class="bd-crumb-inactive" style="cursor: pointer;" (click)="handleNavigation('home')">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a class="bd-crumb-inactive" style="cursor: pointer;" (click)="handleNavigation('browse')">Help Articles</a>
        </li>
        <li class="breadcrumb-item active">{{name}}</li>
      </ol>
    </div>
    <div class="input-group col-md-5 col-5 col-lg-5 searchContainer">
      <ng-autocomplete class="form-control py-2 searchBox" [data]="data" [searchKeyword]="keyword"
        [(ngModel)]="searchKey" (selected)='selectEvent($event)' (inputChanged)='onChangeSearch($event)'
        (inputFocused)='onFocused($event)' [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate"
        (keydown.enter)="onKeyEnterSearch($event,searchKey)" (inputCleared)="searchCleared()" aria-label="Type here to Search an Article"
        placeholder="{{searchTextboxNote}}" title="{{searchTextboxHover}}">
      </ng-autocomplete>
      <ng-template #itemTemplate let-item>
        <a [innerHTML]="item.name"></a>
      </ng-template>
      <ng-template #notFoundTemplate let-notFound>
        No Suggestion...
      </ng-template>
      <span class="input-group-append" (click)="search(searchKey)">
        <button class="btn btn btn-primary searchBtn" type="button" title="{{searchButtonHover}}" aria-label="Click here to Search an Article">
          <i class="fa fa-search"></i>
        </button>
      </span>
    </div>
  </div>
  <div data-auto-dismiss="10000"  *ngIf="alert==true && delayed==false"
  class="alert alert-success alert-dismissible fade show" style="position: absolute; right: 20px; z-index: 999;margin-top: 10px;padding: 0.75rem 1rem;" data-auto-dismiss role="alert">
    <p>Case saved successfully, case number is {{caseAlertMessage}}</p>
</div>
</div>
</div>
</div>
<div class="container">
<h2 class="help" >{{name}}</h2>
</div>

<div class="container p-20">
    <div class="row articles" *ngIf = "topics?.return_body.length > 0"  status="false">
      <div class="col-lg-6"  *ngFor="let topic of topics?.return_body">
        <ul style="list-style-type: none;" >
          <div *ngIf="topic.module=='Script'">
          <a  [routerLink]="['../search']" [queryParams]="{pk: topic.pk,parentPk:this.parentPk}">
        <p class="help-topics-header"  (click)=navigate(topic.pk)>{{topic.stepName}}<span class="topics-count" *ngIf="topic.kbData.count > 0">({{topic.kbData.count}})<i class="fas fa-angle-double-right right-arrow"></i></span></p>
      </a>
      </div>
      <div *ngIf="topic.module=='Link' && topic.navigation=='_blank'">
      <a  href="{{topic.externalUrl}}"  target="_blank" class="help-topics-header">{{topic.stepName}}</a>
    </div>
    <div *ngIf="topic.module=='Link' && topic.navigation=='false'">
      <a  href="{{topic.externalUrl}}" class="help-topics-header">{{topic.stepName}}</a>
    </div>
        <ng-container *ngFor="let kb of topic.kbData.items;let i= index">
          <li class="line" *ngIf="i<3" > 
            <a [routerLink]="['../article']" [queryParams]="{articleId: kb.id,pk:this.pk,childPk:this.parentPk,articleTag:topic.articleTag}">
              <h6 class="article-topic"  [innerHTML]="kb.name"></h6>
            </a>
          </li>
        </ng-container>
        </ul>
      </div>
    </div>
  
  <!-- </div> -->
  <div *ngIf="topics?.return_body.length == 0">
  <div class="row">
  <div class="col-md-12 col-12 col-xs-12 col-lg-8 col-xl-8 empty-record">No results found. Please modify your search criteria.</div>
  <div class="col-md-12 col-12 col-xs-12 col-lg-4 col-xl-4 contact">
    <div class="contact-link">
      <div class="card" style="width: 100%;">
        <div class="card-header" *ngIf="topArticles.total > 0">
          <strong>{{topArticleTitle}}</strong>
        </div>
        <div class="card-body" *ngIf="topArticles.total > 0">
          <ul style="list-style-type:none;padding-left: 20px;">
            <div *ngFor="let article of topArticles.items">
              <a class="top-articles-tooltip" [routerLink]="['../article']" [queryParams]="{articleId: article.article_id}">
              <li class="toparticles-block">{{article.article_title}}</li>
              <span class="top-articles-tooltip-text" style="pointer-events : none;">{{article.article_title}}</span>
            </a>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>